export const ShapeForm = {
  Default: "CustomCircle",
};

export const ShapeType = {
  Blank: 0,
  And: 1,
  Or: 2,
  Xor: 3,
};
export const Circles = {
  [ShapeType.Blank]: "icon-circle",
  [ShapeType.And]: "icon-Circle-up",
  [ShapeType.Or]: "icon-Circle-down",
  [ShapeType.Xor]: "icon-Circle-line",
};

export const SelectionType = {
  Circle: 0,
  Arrow: 1,
};
